import { render, staticRenderFns } from "./Page028.vue?vue&type=template&id=017f2d9b&scoped=true&"
import script from "./Page028.vue?vue&type=script&lang=js&"
export * from "./Page028.vue?vue&type=script&lang=js&"
import style0 from "./Page028.vue?vue&type=style&index=0&id=017f2d9b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017f2d9b",
  null
  
)

export default component.exports